import { render } from "./OGPO.vue?vue&type=template&id=6cc8b3e4&scoped=true"
import script from "./OGPO.vue?vue&type=script&lang=js"
export * from "./OGPO.vue?vue&type=script&lang=js"

import "./OGPO.vue?vue&type=style&index=0&id=6cc8b3e4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cc8b3e4"]])

export default __exports__